enum UsersRoutes {
  Users = 'users',
  Login = 'auth/login',
}

export default UsersRoutes;
